import constants from "../constants";

const {
  // UPDATE_CLIENT_RESERVATIONS_BY_CLIENT_ID,
  // UPDATE_CLIENT_RESERVATIONS_BY_CLIENT_ID_STORE,
  UPDATE_CLIENT_RESERVATIONS,
  UPDATE_CLIENT_RESERVATIONS_STORE,
  UPSERT_CLIENT_RESERVATION,
  UPSERT_CLIENT_RESERVATION_STORE,
  REMOVE_CLIENT_RESERVATION,
  REMOVE_CLIENT_RESERVATION_STORE,
} = constants;

export const updateClientReservations = (data) => ({
  type: UPDATE_CLIENT_RESERVATIONS,
  data,
});

export const updateClientReservationsStore = (data) => ({
  type: UPDATE_CLIENT_RESERVATIONS_STORE,
  data,
});

// export const updateClientReservationsByClientId = (data) => ({
//   type: UPDATE_CLIENT_RESERVATIONS_BY_CLIENT_ID,
//   data,
// });

// export const updateClientReservationsByClientIdStore = (data) => ({
//   type: UPDATE_CLIENT_RESERVATIONS_BY_CLIENT_ID_STORE,
//   data,
// });

export const upsertClientReservation = (clientReservation) => ({
  type: UPSERT_CLIENT_RESERVATION,
  data: clientReservation,
});

export const upsertClientReservationStore = (client) => ({
  type: UPSERT_CLIENT_RESERVATION_STORE,
  data: client,
});

export const removeClientReservation = (data) => ({
  type: REMOVE_CLIENT_RESERVATION,
  data,
});

export const removeClientReservationStore = ({ clientId, removedId }) => ({
  type: REMOVE_CLIENT_RESERVATION_STORE,
  clientId,
  removedId,
});
